
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's03c75db6e18f29d2': `anmelden`,
's03f42eea72154959': `Nutzername`,
's053eb89714fe5c46': `Leistung`,
's05e136e67bf479ad': `Meter`,
's091d5d07b5b33dcf': `OK`,
's09b7ae18afb52426': `Lichtprofil`,
's0a95ea7c8e330485': `Breite`,
's0b43e6e909895c89': `Horizontal`,
's0bd108911963a54f': `kalt`,
's0d249b4af3381730': `Bitte einloggen`,
's0ed0176ae4af6fd2': `Jahresübersicht`,
's0eeef467da6b181a': `Der Ort ist ausschlaggebend für die Konfiguration. Jeder Ort hat andere Begebenheiten.`,
's0fbf6dc6a1966408': `Weiter`,
's101f0e6c075f0306': `Persönliche Beratung`,
's125083191daf6f61': `gering`,
's15299b8255389e31': `Produktmodell`,
's15a852e9f9a50fa5': `Juni`,
's15b92ca12f290f37': `24h Dimmprofil`,
's1667f96d19635ec7': `Zone`,
's18c191e7eabb4ddf': `AETO-Solarkonfigurator – vorübergehend nicht verfügbar`,
's18f78df8a253a3bd': `Diese Konfiguration ändern`,
's1c9fc46adbc800fc': `We konnten den eingegeben Ort nicht finden.`,
's1da50951bdd7a204': `Kanal`,
's2122b8c621efd5fe': `Ausschreibungstext`,
's2138d5192571b731': `neu`,
's25858219b90108cb': `LDT`,
's2652c22671dc46da': `Diese Konfiguration kopieren`,
's26f5f8b809fd7fe5': `Produktbild herunterladen (png)`,
's28414724644bccc4': `Beispieltage`,
's28e1da9966f65d52': `Mögliche Lichtpunkthöhen`,
's2ceb11be2290bb1b': `Abbrechen`,
's2dde18798d6023ff': `Der AETO-Solarkonfigurator wird derzeit aktualisiert und steht deshalb momentan nicht zur Verfügung. Für Unterstützung wenden Sie sich bitte an Ihren Selux-Ansprechpartner.`,
's2deee7c162e1558b': `abmelden`,
's2ee707397f19f23d': `Ganzjahresprofil (max)`,
's2fba71bd651bdbfb': `Vertikal`,
's30c5118924e9ccf7': `Montageanleitung`,
's36a54400db774fd6': `Ort außerhalb des Konfigurationsbereichs`,
's37d9fb643943321e': `Weiter ohne Leuchtenauswahl`,
's38bc43eb653b6341': `Bitte wählen`,
's38cb83ea5c1270b3': `Lichtverteilung`,
's3c04f27ce20ea918': `Gesamthöhe`,
's3f6c9690de6c453d': `Unverschattet, Ausrichtung Leuchtenkopf nach Süden. Referenztage: Sommer 21.Dez., Winter 21.Jul., Frühjahr/Herbst: 21.Sep.`,
's3fda2cc80886276c': `Meter`,
's4394ed0a03867f18': `Lichtpunkthöhe`,
's43fb34257e831c1f': `Unverschattet, Ausrichtung Leuchtenkopf nach Norden. Referenztage: Winter 21.Dez., Sommer 21.Jul., Frühjahr/Herbst: 21.Sep.`,
's464ff0695f87139f': `Für diesen Standort nehmen Sie bitte Kontakt mit uns auf, damit wir Ihnen ein persönliches
					Circulares Lichtprofil erstellen können.
				`,
's47ebf3a8fb3b10c1': `Ausrichtung`,
's48344928cb4a4f8d': `Wählen Sie einen Ort`,
's48e186fb300e5464': `Zeit`,
's5048efbcb03a6a20': `Lichtechnische Daten`,
's5052d10b539eabf0': `März`,
's5390f55090d59178': `Aeto passt sich flexibel an die Umgebungs- und Projektanforderungen an. Ermitteln Sie mit
					unserem Konfigurator anhand statistischer Sonnen- und Wetterdaten der mindestens letzten 10 Jahre
					mögliche Lichtleistungen in Abhängigkeit der Größe der Solareinheit.
				`,
's542a2430b5e7bf68': `Die Sonneneinstrahlung wird ohne Verschattung und mit Ausrichtung nach Norden berechnet.`,
's57eb78864b88cc0e': `Gestaltete schlanke Solarsystemleuchte, die sich flexibel an die Umgebung und den
					Projektanforderungen anpassen lässt.
				`,
's59b52ef0a2362cf4': `Lichtprofil`,
's5dd028a12ddb124b': `Ihr Lichtprofil`,
's5e175dc39575c652': `an/aus`,
's5e399df62bea2918': `warm`,
's61053f0e3ebbd272': `normal`,
's63cc891eb48fbf58': `Ihre Leuchte`,
's66c5b77248cfa1af': `Leuchtendaten`,
's67e5c254c4d8832d': `Email-Anfrage für mehr Informationen`,
's6b61044deda3df65': `Das gewünschte Feature nicht möglich mit zuvor getroffenen Entscheidungen. Wollen Sie diese
					Felder deaktivieren um fortzufahren?
				`,
's6ec56fb545de4b76': `Nehmen Sie gern für einen persönlichen Austausch und weitere Informationen Kontakt mit uns
					auf.
				`,
's7360eecc9b38343d': `hoch`,
's7574e7a84b0fb574': `Sommer`,
's794a2ed0326f8bd3': `Lichtverteilung`,
's7965f9dc5548469e': `Ihre Zone:`,
's79a9ea7671b44bdc': `Konfigurieren Sie für Ihr Projekt die neue effiziente Aeto Solarleuchte.`,
's79aea3f15705d95d': `Naturzentrierte Beleuchtung`,
's7ebe6e1acc5d757a': `Schmal`,
's80629ca60d4d77eb': `Lichtprofil im Detail erleben`,
's84e4ad9f3933d98d': `Für erweiterte Konfigurationsoptionen, bitte`,
's863b04cd4fb72226': `Batteriekapazität`,
's874b4e33320ea9fa': `LDT Seite`,
's8750ed2a956654c9': `Datenblatt`,
's87d32bdbee7f327f': `Ihr Lichtprofil:`,
's89e9be1960f4c21c': `rot`,
's8a957ce1c55ba8f0': `Angemeldet:`,
's8d5cb019f3cae535': `PDF`,
's8d802fff3bde98c3': `Neue Konfiguration starten`,
's904478720bf69a20': `Ausschreibungstext in Zwischenablage kopieren`,
's923a14357bb70193': `Herbst`,
's9822e5e8ef283182': `Lichtintensität`,
's9844ab19fa9b214f': `Sep`,
's9a6e47771188568d': `Verschattung`,
's9ae3ff84f2b87d2b': `PDF herunterladen`,
's9bf7d6fdcd9de5ce': `Aus dieser Erkenntnis entstand die Idee, künstliches Licht natürlichen Rhythmen anzupassen:
					jeden Tag, zu jeder Jahreszeit und an jedem Ort der Welt ein wenig anders – aber immer einzigartig.
				`,
's9d8b8aa2b404c2c8': `Einstellungen`,
's9eba0933010df96e': `Mehr informationen`,
's9f0c705e2fd7e391': `Konfiguration starten`,
'sa1070ff7d8c004c4': `Uhrzeit`,
'sa25de1d82d6a4d4e': `Länge`,
'sa9f14ae61a187f50': `Lichtfarbe`,
'sab08f8abe884ba64': `Solareinheit`,
'sab7cf21360ead74e': `Lichtpunkthöhe (über Basismast)`,
'sab87e31f40553ff2': `Wählen Sie eine Leuchte`,
'sac8252732f2edb19': `Datum`,
'sbb99f4f1499715c1': `Wir freuen uns auf die Zukunft des Lichtes.`,
'sc0bd6202ba1e9149': `Circulares Lichtprofil`,
'sc141922a5906fd93': `Login anfordern`,
'sc1966aa0d7e2d0fe': `Unsere Leuchtenempfehlung`,
'sc1a1ae295cc1f0c3': `Berechne Photovoltaikdaten. Bitte warten ...`,
'sc76a095e1ffa22b6': `mittel`,
'sc8c2558dda210387': `Verschattung`,
'sc956f29d2ff0ef07': `Ort nicht gefunden`,
'sca51b3d6b0d00e47': `Verfügbare Leuchten`,
'sca91d01075c0ce84': `Sonnenaufgang`,
'scb320e45978d3390': `Fabrikat`,
'scc75879e9b6998da': `Lumen`,
'scd5bf30253fea7aa': `Weit`,
'sce10e2a2c48d13c0': `Vielen Dank für Ihr Verständnis.`,
'sce2d17cf5d18dee3': `Kontakt aufnehmen`,
'sd35032a7b73b36ac': `Winter`,
'sd5d820e378ce757e': `Montageanleitung`,
'sd697d9c07465ce87': `Sonnenuntergang`,
'sda2fac80819ad60a': `Insektenaktivität`,
'sdac1a66caafe39b2': `Konfiguration zurücksetzen`,
'sdcb27818fed9da90': `für`,
'sde96c07df45da349': `Familie`,
'se9d2aaa5182ec3fc': `Energieertrag`,
'sec2557a35b702525': `Variable`,
'see2fcaedf9743ec6': `Ort`,
'seed76e8afe9f604a': `Preis`,
'sefcf950b3cc4fc3b': `Sprache`,
'sf4a50a3b63226dd4': `Konfigurationsnummer laden`,
'sf6e1665c7022a1f8': `Passwort`,
'sf922f9970316c369': `Publikumsverkehr`,
'sfcb319624c989982': `Ausgewählte Leuchten`,
'sfd1e1dc1bf9acb1b': `Wie muss Licht wirken um Sicherheit, Orientierung und Schönheit zu schaffen? Wie können wir
					verhindern, unsere ökologischen Grenzen noch weiter zu belasten? Gibt es das perfekte Licht?
					Antworten darauf liefert die Natur.
				`,
'sfe6c68330a2bd563': `Licht im natürlichen Rhythmus für Menschen, Pflanzen und Tiere`,
    };
  